const CreditCardIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 2.3077V13.6923C19.5 14.1974 19.325 14.625 18.975 14.975C18.625 15.325 18.1974 15.5 17.6923 15.5H2.3077C1.80257 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V2.3077C0.5 1.80257 0.675 1.375 1.025 1.025C1.375 0.675 1.80257 0.5 2.3077 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80257 19.5 2.3077ZM1.99998 4.40385H18V2.3077C18 2.23077 17.9679 2.16024 17.9038 2.09613C17.8397 2.03203 17.7692 1.99998 17.6923 1.99998H2.3077C2.23077 1.99998 2.16024 2.03203 2.09613 2.09613C2.03202 2.16024 1.99998 2.23077 1.99998 2.3077V4.40385ZM1.99998 7.5961V13.6923C1.99998 13.7692 2.03202 13.8397 2.09613 13.9038C2.16024 13.9679 2.23077 14 2.3077 14H17.6923C17.7692 14 17.8397 13.9679 17.9038 13.9038C17.9679 13.8397 18 13.7692 18 13.6923V7.5961H1.99998Z"
        fill="#0D0D0D"
      />
    </svg>
  );
};

export default CreditCardIcon;
